export const MULTISELECT_IGNORE_AREA = 30;
